import React, { FC, ReactElement, ReactNode } from 'react';
import { SentryErrorBoundary } from '@features/sentry-connect';

import { logger } from '@shared/lib';

type Props = {
  children: ReactNode;
  renderError: (error: Error) => ReactElement;
};

export const ErrorBoundary: FC<Props> = ({ renderError, children }) => {
  return (
    <SentryErrorBoundary
      beforeCapture={(scope, error, componentStack) => {
        scope.setTag('errorBoundary', 'true');
        scope.setContext('errorBoundary', {
          url: typeof window !== 'undefined' ? window.location.href : null,
          message: error?.message ?? null,
          name: error?.name ?? null,
          componentStack: componentStack ?? null,
          timestamp: new Date().toISOString(),
        });
      }}
      fallback={({ error, componentStack }) => {
        logger.error('Uncaught error:', error, componentStack);
        return renderError(error);
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
};
